import { css } from 'styled-components';
import { Intensities } from "../constants.js";
import getTextStyles from "./getTextStyles/getTextStyles.js";
export var getSharedFieldLabelAndLegendStyles = _ref => {
  var {
    bodyTextSize,
    disabled,
    intensity
  } = _ref;
  var isLightIntensity = intensity === Intensities.LIGHT;
  return css(["color:", ";", ";", ""], isLightIntensity ? 'var(--text-color-dim)' : 'var(--text-color)', getTextStyles.bodyText(bodyTextSize, {
    isBold: !isLightIntensity
  }), disabled && css(["&&{color:var(--gray-5);}"]));
};